export type dataTrendsType = {
  subject: string;
  title: string;
  numTweet: string;
};

export const dataTrends: dataTrendsType[] = [
  {
    subject: "Sports · Trending",
    title: "Tennis",
    numTweet: "4,245k tweets",
  },
  {
    subject: "Business & finance · Trending",
    title: "CAC 40",
    numTweet: "3,115k tweets",
  },
  {
    subject: "Trending",
    title: "APIs",
    numTweet: "2,703 tweets",
  },
  {
    subject: "Trending",
    title: "Politics",
    numTweet: "2,849k tweets",
  },
  {
    subject: "Cinema & entertainment · Trending",
    title: "Theater",
    numTweet: "2,739k tweets",
  },
  {
    subject: "international · Trending",
    title: "World news",
    numTweet: "3,244k tweets",
  },
];
